class LocalizationForm extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list'),
    };
    if (!this.elements.button || !this.elements.panel) return;
    this.elements.panel.removeAttribute('hidden');
    this.elements.panel.classList.add('menu-hidden');
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    this._docClick = this.onDocumentClick.bind(this);
    document.addEventListener('click', this._docClick);
  }

  disconnectedCallback() {
    if (this._docClick) document.removeEventListener('click', this._docClick);
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.classList.add('menu-hidden');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onDocumentClick(event) {
    if (this.contains(event.target)) return;
    this.hidePanel();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector(event) {
    if (event) event.stopPropagation();
    this.elements.panel.classList.toggle('menu-hidden');
    this.elements.button.setAttribute(
      'aria-expanded',
      (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
    );
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
